module.exports = __webpack_public_path__ + "static/media/vejaodo-partitura.756b65dc.png";